/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlDeletedUserResponse } from './ControlDeletedUserResponse';
import {
    ControlDeletedUserResponseFromJSON,
    ControlDeletedUserResponseFromJSONTyped,
    ControlDeletedUserResponseToJSON,
} from './ControlDeletedUserResponse';

/**
 * 
 * @export
 * @interface ControlPaginatedDeletedUserResponse
 */
export interface ControlPaginatedDeletedUserResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedDeletedUserResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedDeletedUserResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedDeletedUserResponse
     */
    total: number;
    /**
     * 
     * @type {Array<ControlDeletedUserResponse>}
     * @memberof ControlPaginatedDeletedUserResponse
     */
    results: Array<ControlDeletedUserResponse>;
}

/**
 * Check if a given object implements the ControlPaginatedDeletedUserResponse interface.
 */
export function instanceOfControlPaginatedDeletedUserResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedDeletedUserResponseFromJSON(json: any): ControlPaginatedDeletedUserResponse {
    return ControlPaginatedDeletedUserResponseFromJSONTyped(json, false);
}

export function ControlPaginatedDeletedUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedDeletedUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(ControlDeletedUserResponseFromJSON)),
    };
}

export function ControlPaginatedDeletedUserResponseToJSON(value?: ControlPaginatedDeletedUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'total': value.total,
        'results': ((value.results as Array<any>).map(ControlDeletedUserResponseToJSON)),
    };
}

